(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('ConsortiumUsers', ConsortiumUsers);

    ConsortiumUsers.$inject = ['$resource'];

    function ConsortiumUsers ($resource) {
        var resourceUrl =  'api/consortium-users';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
